import api from "../axios";

const getAccountId = () => sessionStorage.getItem("acc_id");
const getLocationId = () =>
  JSON.parse(sessionStorage.getItem("current_loc") || "{}")?.id;

export const REPORT_HISTORY_STATUS = {
  GENERATED: "generated",
  SUBMITTED: "submitted",
  CLOSED_WITHOUT_SUBMISSION: "closed_without_submission",
};

const ALLOWED_STATUSES = new Set(Object.values(REPORT_HISTORY_STATUS));

// SCRUM-920: "Result per page" options on the History page; 25 is the default.
export const PAGE_SIZE_OPTIONS = [5, 10, 25];
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 25;


export const validateReportHistoryFilters = ({
  startDate,
  endDate,
  page,
  pageSize,
} = {}) => {
  if ((startDate && !endDate) || (!startDate && endDate)) {
    return "Select both a start and end date, or clear the date range.";
  }
  if (page != null && page < 1) {
    return "Page must be 1 or greater.";
  }
  if (pageSize != null && pageSize < 1) {
    return "Page size must be 1 or greater.";
  }
  return null;
};

const buildHistoryParams = ({
  provider,
  status,
  startDate,
  endDate,
  page,
  pageSize,
}) => {
  const params = { location: getLocationId() };
  if (provider) params.provider = provider;
  if (status && ALLOWED_STATUSES.has(status)) params.status = status;
  if (startDate && endDate) {
    params.start_date = startDate;
    params.end_date = endDate;
  }
  if (page) params.page = Math.max(page, 1);
  params.page_size = Math.min(Math.max(pageSize || DEFAULT_PAGE_SIZE, 1), MAX_PAGE_SIZE);
  return params;
};


export const getReportHistory = async ({
  provider,
  status,
  startDate,
  endDate,
  page,
  pageSize,
} = {}) => {
  const accountId = getAccountId();
  const response = await api.get(
    `/rpm/${accountId}/out-of-range/reports/history/`,
    { params: buildHistoryParams({ provider, status, startDate, endDate, page, pageSize }) }
  );
  return response.data;
};

export default getReportHistory;
